module.exports = __webpack_public_path__ + "static/img/logonew.34538ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logonew.jpg
// module id = bCoZ
// module chunks = 3